/**
 * Plugin Loader
 *
 * Registers the inference plugins and this editor's tools, then freezes the
 * plugin registry. The single import entry point for consumers that need
 * every tool loaded (e.g. tool-registry.ts).
 */

// ── Self-registering inference plugins (side-effect imports) ──

import '../inference/sharp';
import '../inference/pointcloud';
import '../inference/sam3d';
import '../inference/mapanything-ply';
import '../inference/mapanything-glb';
import '../inference/trellis2';
import '../inference/route';

import { EDITOR_TOOLS, registerEditorTools } from '../ai/tools/editor-tools';

registerEditorTools(EDITOR_TOOLS);
